import React from 'react';
import PropTypes from 'prop-types';
import { actions, Control, LocalForm } from 'react-redux-form';
import Select from 'react-select';
import { titleize } from 'utils/strings';

import './styles/token_inserter.scss';

class TokenInserter extends React.Component {
  static propTypes = {
    onInsert: PropTypes.func.isRequired,
    prefix: PropTypes.string,
    tokens: PropTypes.object.isRequired
  };

  static defaultProps = {
    prefix: '',
    tokens: {}
  };

  constructor(props) {
    super(props);

    this.form = null;
    this.formDispatch = null;
    this.state = {
      availableTokens: []
    };
  }

  render() {
    const {prefix, onInsert, tokens} = this.props;
    const model = `${prefix !== '' ? prefix + '.' : ''}tokenSelector`;
    const categoriesForSelect = Object.keys(tokens).map((group) => ({value: group, label: titleize(group)}));

    function transformOptions(options) {
      /*
       *  The options hash from the server is structured as such:
       *
       *  {
       *    token_value1: 'Token Print Name 1',
       *    token_value2: 'Token Print Name 2',
       *    Token Category Name 1: {
       *      token_value2: 'Token Print Name 3',
       *      token_value4: 'Token Print Name 4'
       *    },
       *    Token Category Name 2: {
       *      token_value2: 'Token Print Name 5',
       *      token_value4: 'Token Print Name 6'
       *    }
       *  }
       *
       *  Therefore, we must observe the values to determine if
       *  we are dealing with a category or a simple token.
       * */
      const option = (value, label, render, disabled = false) => ({value, label, render, disabled});
      return Object.entries(options).reduce((acc, [key, value]) => {
        // {canonical_name: 'Display Name'}
        if (typeof value === 'string') {
          return acc.concat(option(key, value, value));
          // {'Category Display Name': {...}}
        } else {
          const parent = option(null, key, (<strong style={{color: '#000'}}>{key}</strong>), true);
          const children =
            Object.entries(value)
              .map(([childValue, childTokenName]) => option(
                childValue,
                childTokenName,
                <div style={{paddingLeft: 10}}>{childTokenName}</div>
              ));
          // Do not include social_security_number in options
          if ("social_security_number" in value) {
            return acc.concat(parent);
          } else {
            return acc.concat(parent).concat(children);
          }
        }
      }, []);
    }

    return <LocalForm
      className="token-selector"
      onSubmit={(values) => onInsert(values)}
      model={`${model}`}
      component="div"
      getDispatch={(dispatch) => {
        this.formDispatch = dispatch
      }}
      ref={(form) => {
        this.form = form
      }}
    >
      <Control
        className="token-category"
        model={`.category`}
        options={categoriesForSelect}
        component={Select}
        mapProps={{
          onChange: (props) => (selected) => {
            props.onChange(selected ? selected.value : null);
            this.formDispatch(actions.reset(`${model}.token`));
            this.setState({availableTokens: selected ? tokens[selected.value] : []});
          }
        }}
        validators={{required: (val) => val && val.length}}
      />
      <Control
        className="token-select"
        model={`.token`}
        options={transformOptions(this.state.availableTokens)}
        component={Select}
        optionRenderer={option => option.render}
        mapProps={{
          onChange: (props) => (selected) =>
            props.onChange(selected ? selected.value : null)
        }}
        validators={{required: (val) => val && val.length}}
      />
      <button
        type="button"
        className="btn btn-primary token-insert"
        onClick={() => this.formDispatch(actions.submit(`${model}`))}
      >
        Insert
      </button>
      <div className="clear"/>
    </LocalForm>;
  }
}

export default TokenInserter;
